import { Controller } from "stimulus";
import {loadDataVehicles, loadRegionData, loadRibbonColours} from "../utils/controller-helper";

export default class extends Controller {
    static targets = [
        "frame",
        "list",
        "left",
        "right"
    ];

    async initialize() {
        try {
            const regionResponse = await loadRegionData()
            const ribbonData = await loadRibbonColours();
            const vehicleResponse = await loadDataVehicles();

            import(/* webpackChunkName: "vehicle-tiles" */ '../components/VehicleTiles').then(module => {
                module.default(this.listTarget, {
                    slider: this.element,
                    frame: this.frameTarget,
                    list: this.listTarget,
                    left: this.leftTarget,
                    right: this.rightTarget,
                    regions: regionResponse,
                    ribbonData: ribbonData,
                    vehicles: vehicleResponse
                });

            })
        } catch (e) {

        }
    }
}